import type { FaireBrandEntity } from "../../entity_types/brand";

export const b_live_ayoh_foods: FaireBrandEntity = {
  token: "b_live_ayoh_foods",
  type: "brand",
  name: "AYOH Foods",
  location: "Golden, Colorado",
  logoUrl:
    "https://cdn.faire.com/fastly/9ff92ee0d72f64b5fa578928150466c3ccd814da728749df0f5465b49a57c2c9.jpeg?fit=crop&format=jpg&height=96&width=96",
  avatarUrl:
    "https://cdn.faire.com/fastly/9ff92ee0d72f64b5fa578928150466c3ccd814da728749df0f5465b49a57c2c9.jpeg?fit=crop&format=jpg&height=96&width=96",
  description:
    "Created by chef and cookbook author Molly Baz, AYOH is reinventing mayo with bold, craveable flavors—from Dill Pickle to Hot Giardinayo to Miso Mayo. Made with cage-free eggs and clean ingredients. Available at Whole Foods, Sprouts, and Walmart nationwide.",
  minimumOrderDollars: 108,
  rating: 4.9,
  tags: ["live-shopping", "food"],
  meta: {
    source: "mock",
    importedAt: "2026-03-24T00:00:00.000Z",
    importedBy: "live-shopping-migration",
  },
};
